module.exports = __webpack_public_path__ + "23a5ee40ded5c16069d3709392355c3b.svg";